<template>
  <div class="havet-editor pa-3" v-if="editor">
    <bubble-menu rounded :editor="editor" :tippy-options="{ duration: 100 }" v-if="editor">
      <v-btn-toggle dark>
        <v-btn
          small
          :class="{
            'v-item--active v-btn--active':
              'isActive' in b && editor.isActive(b.isActive.name, b.isActive.params),
          }"
          v-for="b in buttonGroupFour"
          :key="b.id"
          @click="runCommand(b.command)"
        >
          <v-icon small>{{ b.icon }}</v-icon>
        </v-btn>
        <v-btn small :class="{ 'is-active': editor.isActive('link') }" @click="setLink">
          <v-icon small>mdi-link</v-icon>
        </v-btn>
      </v-btn-toggle>
    </bubble-menu>
    <editor-content class="editor__content" :editor="editor" />
    <InsertImageDialog ref="InsertImageDialog" />
    <v-btn class="edit-button" icon @click="toggleDisable">
      <v-icon :color="editable ? 'primary' :'' ">mdi-square-edit-outline</v-icon>
    </v-btn>
  </div>
</template>

<script>
import unescape from 'lodash/unescape'
import { Editor, EditorContent, BubbleMenu } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Image from '@tiptap/extension-image'
import Underline from '@tiptap/extension-underline'
import Link from '@tiptap/extension-link'
import { buttonGroupOne, buttonGroupTwo, buttonGroupThree, buttonGroupFour } from './buttonGroups'
import InsertImageDialog from './InsertImageDialog'

export default {
  props: {
    loading: {
      type: Boolean,
    },
    data: {
      type: String,
    },
    theme: {
      type: String,
    },
    small: {
      type: Boolean,
      default: false,
    },
    maxmimizedUI: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EditorContent,
    BubbleMenu,
    InsertImageDialog,
  },
  data() {
    return {
      keepInBounds: true,
      editor: null,
      saving: false,
      overlay: true,
      linkUrl: null,
      linkMenuIsActive: false,
      buttonGroupOne,
      buttonGroupTwo,
      buttonGroupThree,
      buttonGroupFour,
      editable: false,
    }
  },
  watch: {
    data() {
      this.editor.commands.setContent(unescape(this.data))
    },
  },
  mounted() {
    const self = this
    this.editor = new Editor({
      onUpdate({ editor }) {
        self.$emit('editor:update', { data: editor.getHTML() })
      },
      extensions: [
        StarterKit.configure({
          history: true,
        }),
        Image,
        Underline,
        Link,
      ],
      autoFocus: true,
      content: unescape(this.data),
      editable: false,
    })
    this.overlay = false
    
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  computed: {},
  methods: {
    toggleDisable() {
      this.editable = !this.editable
      this.editor.setEditable(this.editable)
      if (this.editable) {
        this.editor.commands.focus()
      }
    },
    onResize() {
      this.$emit('editor:resize', !this.maxmimizedUI)
    },
    async runCommand({ name, params }) {
      if (!name) return
      await this.editor.chain().focus()[name](params).run()
    },
    async setLink() {
      const previousUrl = this.editor.getAttributes('link').href

      const url = await this.$refs.InsertImageDialog.open({
        title: 'Lägg till länk',
        message: 'Skriv url till bilden du vill lägga in.',
        label: 'Url',
        value: previousUrl,
      })

      // cancelled
      if (url === null) {
        return
      }

      // empty
      if (url === '') {
        this.editor.chain().focus().extendMarkRange('link').unsetLink().run()
        return
      }
      // update link
      this.editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
    },
    async addImage() {
      const {url, alt} = await this.$refs.InsertImageDialog.open({
        title: 'Lägg till bild',
        message: 'Skriv url till bilden du vill lägga in.',
        label: 'Url',
      })

      if (url) {
        this.editor.chain().focus().setImage({ src: url, alt }).run()
        this.editor.commands.unsetAllMarks()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.havet-editor {
  margin: auto;
  position: relative;
  background-color: #eee;
  max-width: 100%;
  overflow: scroll;
  :focus {
    outline: -webkit-focus-ring-color auto 0px;
  }
  .edit-button{
    position: absolute;
    bottom:2px;
    right:2px;
  }
  .editor__content {
    height: 100%;
    font-size: 14px;
      max-width: 100%;
  overflow: auto;
  }
  .youtube-iframe {
    width: 100%;
    padding: 10px;
    padding-left: 20px;
    height: 400px;
  }
  .editor-menu-bar {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
  }
  .editor-menu-bar-small {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 4px;
  }
}
</style>
